import styled from "styled-components";
import { useNavigate } from "react-router-dom";

interface TopBarProps { title: string; color?: string; }
export default function TopBar({ title }: TopBarProps) {
  const navigate = useNavigate();
  return <Header><BackButton type="button" aria-label="뒤로가기" onClick={() => navigate(-1)}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m14 5-7 7 7 7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
  </BackButton><h1>{title}</h1></Header>;
}
const Header = styled.header`
  box-sizing:border-box;position:sticky;top:0;z-index:10;flex-shrink:0;display:flex;align-items:center;justify-content:center;
  width:100%;max-width:500px;min-height:60px;padding:12px 60px;background:var(--user-surface);color:var(--user-text);
  border-bottom:1px solid var(--user-border);h1{margin:0;font-size:18px;line-height:1.5;font-family:var(--font-Pretendard-SemiBold);}
`;
const BackButton = styled.button`
  position:absolute;left:8px;display:grid;place-items:center;width:44px;height:44px;padding:0;border:0;border-radius:8px;background:transparent;color:inherit;cursor:pointer;
  &:focus-visible{outline:2px solid var(--user-accent);outline-offset:2px;}
`;
